import { ISidebarItemProps } from '../../../../interfaces/Common';
import { Text } from './styles';

type SubMenuItem = Pick<ISidebarItemProps, 'title'>;

export function SubMenuItem({ title }: SubMenuItem) {
  return <Text isSubMenuTitle>{title}</Text>;
}
